import _slicedToArray from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HeadCom from "../headCom";
import createChild from "./createChild";
import elSelectCityChose from '@/components/elSelectCityChose/elSelectCityChose.vue';
import commonDialog from "@/components/commonDialog/commonDialog.vue";
export default {
  props: {
    router: {
      type: String,
      default: null
    }
  },
  components: {
    elSelectCityChose: elSelectCityChose,
    HeadCom: HeadCom,
    createChild: createChild,
    commonDialog: commonDialog
  },
  data: function data() {
    return {
      page: 1,
      size: 10,
      totalCount: 0,
      //总数
      totleListCount: 1,
      childData: {},
      //详情数据
      areas: {
        //区域
        province: '不限',
        city: '不限',
        country: '不限'
      },
      showCreate: false,
      //是否打开遮罩弹框
      title: '',
      //区分页面标题
      searchValue: {
        address: '',
        type: 0
      },
      // currentPage: 1, //当前页
      tableDateDec: [{
        prop: 'userName',
        value: '用户名',
        minWidth: '100px'
      }, {
        prop: 'userLoginName',
        value: '姓名',
        minWidth: '100px'
      }, {
        prop: 'userRoleName',
        value: '角色',
        minWidth: '120px'
      }, {
        prop: 'userPhone',
        value: '手机号',
        minWidth: '140px'
      }, {
        prop: 'userEmail',
        value: '邮箱',
        minWidth: '140px'
      }, {
        prop: 'createTime',
        value: '创建时间',
        minWidth: '140px'
      }, {
        prop: 'opreate',
        value: '操作',
        minWidth: '240px'
      }],
      // 表格数据
      tableData: [],
      BohanMode: [{
        label: '不限',
        value: 0
      }, {
        label: '电子保函',
        value: 1
      }, {
        label: '纸质保函',
        value: 2
      }],
      // 是否显示角色绑定弹框
      isShowDialog: false,
      // 角色下拉选项
      roleOptions: [],
      // 绑定角色数据
      userRoleForm: {
        userRoleId: ""
      },
      // 当前选中的用户数据(用于修改完角色更新列表)
      currentTableData: {},
      // 当前选中table的index
      currentIndex: 0
    };
  },
  watch: {
    area: function area(obj1, obj2) {
      if (obj1 != null) {
        this.getAllaccount();
      }
    }
  },
  computed: {
    showAdd: function showAdd() {
      return this.userInfo.sonFlag != 1;
    }
  },
  created: function created() {
    // // 子账户或者其他模块的移除操作列
    if (this.router || this.userInfo.sonFlag == 1) {
      this.tableDateDec.pop();
    } // 处理列表字段(非担保机构移除角色字段)


    if (this.userInfo.userType != "2") {
      this.tableDateDec.forEach(function (item, index, lists) {
        if (item.prop === "userRoleName") {
          lists.splice(index, 1);
        }
      });
    } // 获取角色列表


    this.getUserOptions();
  },
  mounted: function mounted() {
    if (this.area != null) {
      for (var key in this.area) {
        this.$set(this.areas, key, this.area[key]);
      }
    }

    if (this.router == 'approvaled') {
      this.title = '已审核';
    } else if (this.router == 'approvaling') {
      this.title = '待审核';
    } else if (this.router == null) {
      this.title = '子账户管理';
    }

    this.getAllaccount();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getAllaccount();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getAllaccount();
    },
    //获取所有子账号
    getAllaccount: function getAllaccount() {
      var _this = this;

      this.requestAPI.childAccount.query({
        parentId: this.userInfo.parentId ? this.userInfo.parentId : this.userInfo.userId,
        page: this.page,
        size: this.size
      }).then(function (res) {
        var data = [];
        res.data.content.forEach(function (item) {
          item.sonAreas = "".concat(item.province).concat(item.city).concat(item.district);
        });
        _this.tableData = res.data.content;
        _this.totalCount = res.data.totalCount;
      }).catch(function () {
        _this.tableData = [];
        _this.totalCount = 0;
      });
    },
    //获取省
    provinceChange: function provinceChange(value) {
      this.areas.province = value;
    },
    //获取市
    cityChange: function cityChange(value) {
      this.areas.city = value;
    },
    //获取区
    countryChange: function countryChange(value) {
      this.areas.country = value;
    },
    //页面头部模糊查询
    searchFun: function searchFun() {
      var _this2 = this;

      var data = {};
      data['province'] = this.area.province != '不限' ? this.area.province : '';
      data['city'] = this.area.city != '不限' ? this.area.city : '';
      data['district'] = this.area.country != '不限' ? this.area.country : '';
      data['parentId'] = this.userInfo.parentId ? this.userInfo.parentId : this.userInfo.userId;

      if (this.searchValue.type != 0) {
        data['type'] = this.searchValue.type;
      }

      this.requestAPI.childAccount.queryAccount(data).then(function (res) {
        res.data.forEach(function (item) {
          item.sonAreas = "".concat(item.province).concat(item.city).concat(item.district);
        });
        _this2.tableData = res.data;
      });
    },
    //重置按钮 清空收缩条件
    reset: function reset() {
      this.searchValue.type = 0;
      this.areas.province = '不限';
      this.areas.city = '不限';
      this.areas.country = '不限';
      this.getAllaccount();
    },
    addSuccess: function addSuccess(obj) {
      this.showCreate = false;
      this.getAllaccount();
    },
    //新建
    showCreateFun: function showCreateFun() {
      // console.log(this.childData,'触发')
      this.childData = null;
      this.showCreate = true; // this.childData = null
    },
    resetPwd: function resetPwd(index) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this3.$confirm("是否确认重置密码？", "提示", {
                  type: "warning",
                  cancelButtonText: "取消",
                  confirmButtonText: "确定",
                  closeOnClickModal: false
                });

              case 3:
                result = _context.sent;

                if (result === "confirm") {
                  _this3.requestAPI.sonResetAcco({
                    userId: _this3.tableData[index].userId
                  }).then(function (res) {
                    _this3.$message.success('重置密码成功!');
                  });
                }

                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    //编辑按钮 打开弹框
    open1: function open1(index) {
      var Detaildata = this.tableData[index];
      Detaildata.userPwd = ''; // this.childData = Detaildata
      // 为了子组件能监听childData数据，每次赋值为新的变量

      this.childData = _objectSpread({}, Detaildata);
      this.showCreate = true;
    },
    // dialog弹框点击关闭图标时的回调(默认点击关闭图标时不会清空数据，此处手动清除)
    clickClose: function clickClose(done) {
      this.$refs.createChildRef.del();
      done();
    },
    //查看详情  跳转详情页
    open2: function open2(index) {
      this.$router.push("/internalSystem/enterpriseAccess/qudaoAccessDetail");
    },
    // 删除
    open: function open(item, index) {
      var _this4 = this;

      this.$confirm('您确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.requestAPI.childAccount.deleteAccount({
          userName: item.userName,
          parentId: _this4.userInfo.userId
        }).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '操作成功'
          });

          _this4.tableData.splice(index, 1);
        });
      }).catch(function () {// this.$message({
        // 	type: 'info',
        // 	message: '取消'
        // });
      });
    },
    // 调用角色列表的接口(放在页面初始化的时候调)
    getUserOptions: function getUserOptions() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this5.requestAPI.getRoleList({
                  roleEnterpriseId: _this5.userInfo.enterpriseId
                });

              case 3:
                result = _context2.sent;

                if (result.errorCode == "0000") {
                  _this5.roleOptions = result.data;
                }

                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    // 打开角色绑定
    openUserRole: function openUserRole(row, index) {
      this.isShowDialog = true;
      this.currentTableData = _objectSpread({}, row);
      this.currentIndex = index;
      this.userRoleForm.userRoleId = this.currentTableData.userRoleId;
    },
    // 确定绑定角色
    sureChangeRole: function sureChangeRole() {
      var _this6 = this;

      this.$refs.userRoleRef.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var obj, result, _this6$roleOptions$fi, _this6$roleOptions$fi2, roleList;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!valid) {
                    _context3.next = 6;
                    break;
                  }

                  obj = {
                    userId: _this6.currentTableData.userId,
                    userRoleId: _this6.userRoleForm.userRoleId
                  };
                  _context3.next = 4;
                  return _this6.requestAPI.setUserRole(obj);

                case 4:
                  result = _context3.sent;

                  if (result.errorCode == "0000") {
                    _this6.$message.success(result.errorMsg); // 获取选中角色数据


                    _this6$roleOptions$fi = _this6.roleOptions.filter(function (item) {
                      return item.roleId === _this6.userRoleForm.userRoleId;
                    }), _this6$roleOptions$fi2 = _slicedToArray(_this6$roleOptions$fi, 1), roleList = _this6$roleOptions$fi2[0];

                    _this6.$set(_this6.currentTableData, "userRoleId", roleList.roleId);

                    _this6.$set(_this6.currentTableData, "userRoleName", roleList.roleName);

                    _this6.tableData.splice(_this6.currentIndex, 1, _this6.currentTableData);

                    _this6.isShowDialog = false;
                  }

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};